module.exports = __webpack_public_path__ + "img/konfigurator-tooltip-spiegel-05.9a1395be.jpg";